export default __webpack_public_path__ + "static/media/pkg.cf11affb.svg";